module.exports = __webpack_public_path__ + "static/media/flyer-new.3cf0d779.jpeg";